import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';

const ID = '19';
const IABid = [52];

export const createPixel = (): HTMLIFrameElement => {
  const cacheBuster = Math.floor(Math.random() * 11000);
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `https://secure-assets.rubiconproject.com/utils/xapi/multi-sync.html?r=${cacheBuster}&p=11868&endpoint=us-east`;

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const iframe = createPixel();
    fastdom.mutate(function userSyncRubiconAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
